// A persisted boolean flag ('1' in localStorage), tolerant of storage failures
// (private mode / quota) — the flag just won't persist across reloads.
export const storageFlag = (key: string) => ({
  get: (): boolean => {
    try {
      return localStorage.getItem(key) === '1'
    } catch {
      return false
    }
  },
  set: () => {
    try {
      localStorage.setItem(key, '1')
    } catch {
      // No-op.
    }
  },
  clear: () => {
    try {
      localStorage.removeItem(key)
    } catch {
      // No-op.
    }
  },
})
